import { useEffect, useState, useRef } from 'react';
import { AllUsersForZonesQuery, useAllUsersForZonesQuery } from '@/__generated__/graphql';

type UseAllUsersForZonesProps = {
  searchTerm?: string;
};

export const useAllUsersForZones = ({ searchTerm }: UseAllUsersForZonesProps = {}) => {
  const [users, setUsers] = useState<AllUsersForZonesQuery['allUsers']>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [shouldLoadMoreUsers, setShouldLoadMoreUsers] = useState<boolean>(true);
  const [hasMoreUsers, setHasMoreUsers] = useState<boolean>(true);
  const previousUserCount = useRef<number>(0);

  const { loading: isLoading, refetch } = useAllUsersForZonesQuery({
    variables: {
      pageInfo: {
        limit: currentPage * 7,
      },
      input: {
        q: searchTerm,
      },
    },
    onCompleted(data) {
      if (data.allUsers.length === previousUserCount.current && data.allUsers.length > 0) {
        setHasMoreUsers(false);
      }
      previousUserCount.current = data.allUsers.length;
      setUsers(data.allUsers);
      setShouldLoadMoreUsers(false);
    },
  });

  useEffect(() => {
    setCurrentPage(1);
    previousUserCount.current = 0;
    setHasMoreUsers(true);
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm !== undefined || (shouldLoadMoreUsers && hasMoreUsers)) {
      refetch();
    }
  }, [searchTerm, shouldLoadMoreUsers, refetch, hasMoreUsers]);

  return {
    users,
    isLoading,
    currentPage,
    hasMoreUsers,
    setCurrentPage,
    setShouldLoadMoreUsers,
    setHasMoreUsers,
  };
};
